import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "completion-view__illustration"
}
const _hoisted_2 = { class: "completion-view__content" }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { class: "completion-view__actions" }

import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/store/userStore'
import { useBikeStore } from '@/store/bikeStore'
import { useMeasurementStore } from '@/store/measurementStore'
import TitleBar from '@/components/layout/TitleBar.vue'
import BikeSetupFinished from '@/components/preview/BikeSetupFinished.vue'
import FinishedSetup from '@/components/setup/FinishedSetup.vue'
import { ButtonType, ButtonState, BfButton } from '@finetic/bikefitting-ui'
import { useI18n } from 'vue-i18n'
import { NModal } from 'naive-ui'
import { getConfig } from '@/config'


export default /*@__PURE__*/_defineComponent({
  __name: 'CompletionView',
  setup(__props) {

const { t } = useI18n()
const router = useRouter()
const userStore = useUserStore()
const bikeStore = useBikeStore()
const measurementStore = useMeasurementStore()

const updated = ref(false)
const showModal = ref(false)

const previous = () => {
  router.push({ name: 'data' })
}

const next = () => {
  showModal.value = true
}

const finish = () => {
  showModal.value = false
  updated.value = true
}

const backToPortal = () => {
  const customerId = userStore.customerId
  const sessionId = userStore.sessionId
  const bikeNo = bikeStore.bikeNo

  const handlebarX = measurementStore.latestMeasurement.handlebar.x
  const handlebarY = measurementStore.latestMeasurement.handlebar.y
  const saddleX = measurementStore.latestMeasurement.saddle.x
  const saddleY = measurementStore.latestMeasurement.saddle.y

  const redirectUrl = `${getConfig('VUE_APP_PORTAL_URL')}/BikeSetup/ReverseCalculation/${customerId}?handlebarX=${handlebarX}&handlebarY=${handlebarY}&saddleX=${saddleX}&saddleY=${saddleY}&bikeNo=${bikeNo}&sessionId=${sessionId}`

  userStore.logout()

  location.href = redirectUrl
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(['completion-view', { 'completion-view--updated': updated.value }])
    }, [
      (!updated.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(BikeSetupFinished)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        (!updated.value)
          ? (_openBlock(), _createBlock(TitleBar, {
              key: 0,
              title: _unref(t)('steps.completion')
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BfButton), {
                  type: _unref(ButtonType).Outlined,
                  icon: "/icons/52-Arrows-Diagrams/01-Arrows/arrow-left-1.svg",
                  onClick: previous
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('common.previous')), 1)
                  ]),
                  _: 1
                }, 8, ["type"]),
                _createVNode(_unref(BfButton), { onClick: next }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('common.finish')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true),
        (!updated.value)
          ? (_openBlock(), _createBlock(FinishedSetup, { key: 1 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("h1", null, _toDisplayString(_unref(t)('completion.updateXY.success.title')), 1),
              _createElementVNode("p", null, _toDisplayString(_unref(t)('completion.updateXY.success.content')), 1),
              _createVNode(_unref(BfButton), { onClick: backToPortal }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('completion.updateXY.backToPortal')), 1)
                ]),
                _: 1
              })
            ]))
      ])
    ], 2),
    _createVNode(_unref(NModal), {
      show: showModal.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((showModal).value = $event)),
      style: {"width":"600px"},
      preset: "card",
      title: _unref(t)('completion.confirmation.title'),
      bordered: false,
      size: "huge",
      "transform-origin": "center"
    }, {
      action: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(BfButton), {
            type: _unref(ButtonType).Outlined,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showModal.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('common.cancel')), 1)
            ]),
            _: 1
          }, 8, ["type"]),
          _createVNode(_unref(BfButton), {
            state: _unref(ButtonState).Enabled,
            type: _unref(ButtonType).Contained,
            onClick: finish
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('common.finish')), 1)
            ]),
            _: 1
          }, 8, ["state", "type"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(_unref(t)('completion.confirmation.line1')), 1),
        _createElementVNode("p", null, _toDisplayString(_unref(t)('completion.confirmation.line2')), 1),
        _createElementVNode("p", null, _toDisplayString(_unref(t)('completion.confirmation.line3')), 1)
      ]),
      _: 1
    }, 8, ["show", "title"])
  ], 64))
}
}

})